export var CONTEXT_UPDATE = 'dismissableLayer.update';
export var POINTER_DOWN_OUTSIDE = 'dismissableLayer.pointerDownOutside';
export var FOCUS_OUTSIDE = 'dismissableLayer.focusOutside';